<template>
   <div class="container">
      <div class="flex justify-center items-center pb-5 pt-16">
         Made with
         <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="white"
            width="15"
            height="15"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-heart mx-1 hover:fill-red-500">
            <path
               d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
         </svg>
         Makassar, Indonesia
      </div>
   </div>
</template>

<script>
export default {};
</script>

<style></style>
